// CloudFront CDN host fronting the `meet-production` bucket. Static brand assets
// (favicons, images, logos, fonts, PDFs) are served through this distribution
// instead of the raw S3 origin (meet-production.s3.us-west-1.amazonaws.com) so
// they load from an edge POP near the user. The host is env-invariant — the same
// bucket backs every environment — so a plain constant is sufficient.
export const ASSETS_HOST = "https://d1q3eb4xyp65cy.cloudfront.net";

// Builds a CDN URL from a bucket-relative path (with or without a leading slash).
export const assetUrl = (path: string) =>
  `${ASSETS_HOST}/${path.replace(/^\//, "")}`;
